module.exports = __webpack_public_path__ + "img/delux-vehicle-filter.0b9941fd.png";